import { Link } from "react-router-dom";
import { usePopup } from "../context/PopupContext";
import { yachtTypes } from "../data/yachtTypesData";

type MasonryGridCard = {
    imageText: string;
    image: string;
    subtitle?: string;
    link?: string;
};

const defaulData: MasonryGridCard[] = yachtTypes.map(({ title, image, link, subtitle }) => ({
    imageText: title,
    image,
    title,
    subtitle,
    alt: title,
    link: link ?? "/",
}));

type MasonryGridProps = {
    sectionId?: string;
    sectionSubtitle?: string;
    sectionTitle?: string;
    sectionAnnotation?: string;
    items?: MasonryGridCard[];
};



function GridPanelItem(
    { subtitle, imageText, image, link }: MasonryGridCard) {
    const { openPopup } = usePopup();

    return (
        <Link
            to={link ? link : "/location"}
            className="grid-panel-item"
            style={{ backgroundImage: `url('${image}')` }}
        >
            <div className="item-subtitle">{subtitle}</div>
            <div className="item-title">{imageText}</div>
        </Link>
    );
}

function ImageMasonryGrid({
    sectionId = "imageMasonryGrid",
    sectionSubtitle = "Yacht Collections",
    sectionTitle = "Every Style, Every Sea",
    sectionAnnotation = "From sleek catamarans to classic motor yachts – find your perfect way to sail",
    items = defaulData,
}: MasonryGridProps) {
    const cuttedItems = items.slice(0, 6);
    const leftPanelItems = [];
    const rightPanelItems = [];

    if (leftPanelItems.length === 0 && rightPanelItems.length === 0) {
        const midIndex = Math.ceil(cuttedItems.length / 2);
        leftPanelItems.push(...cuttedItems.slice(0, midIndex));
        rightPanelItems.push(...cuttedItems.slice(midIndex));
    }

    return (
        <section className="grid-section" id={sectionId}>
            <div className="container">
                <h3 className="section-subtitle">{sectionSubtitle}</h3>
                <h2 className="section-title">{sectionTitle}</h2>
                <h4 className="section-annotation">{sectionAnnotation}</h4>
            </div>

            <div className="grid-content-panel">
                <div className="grid-panel-left">
                    {leftPanelItems.map((item, index) => (
                        <GridPanelItem
                            key={index}
                            subtitle={item?.subtitle}
                            imageText={item.imageText}
                            image={item.image}
                            link={item?.link}
                        />
                    ))}
                </div>
                <div className="grid-panel-right">
                    {rightPanelItems.map((item, index) => (
                        <GridPanelItem
                            key={index}
                            subtitle={item?.subtitle}
                            imageText={item.imageText}
                            image={item.image}
                            link={item?.link}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default ImageMasonryGrid;